import type { ComponentProps } from 'react';

import { cn } from '@repo/lib/cn';

import { Separator } from '@/components/ui/separator';
import { HeadingDropdownMenu, UndoRedoButton } from '@/components/ui/tiptap/tiptap-ui';
import { EmojiCommand } from '@/components/ui/tiptap/tiptap-ui/emoji-command';
import { ListDropdownMenu } from '@/components/ui/tiptap/tiptap-ui/list-dropdown-menu';
import { MarkButton } from '@/components/ui/tiptap/tiptap-ui/mark-button';
import { SelectMediaButton } from '@/components/ui/tiptap/tiptap-ui/select-media';
import { CellActionButton, InsertTablePopover } from '@/components/ui/tiptap/tiptap-ui/table';
import { AddColRowDropdownMenu } from '@/components/ui/tiptap/tiptap-ui/table/add-col-row-dropdown-menu';
import { DeleteDropdownMenu } from '@/components/ui/tiptap/tiptap-ui/table/delete-dropdown-menu';
import { ToggleHeaderDropdownMenu } from '@/components/ui/tiptap/tiptap-ui/table/toggle-header-dropdown-menu';
import { TextAlignButton } from '@/components/ui/tiptap/tiptap-ui/text-align-button';

export function TiptapToolbar(tiptapToolbarProps: ComponentProps<'div'>) {
  const { className, ...props } = tiptapToolbarProps;
  const toolbarBtnClassName: string = 'min-h-8 h-8';
  const toolbarSeparatorClassName: string = 'mx-1 h-full min-h-5 max-h-5 last:hidden first:hidden';
  return (
    <div className={cn('hide-duplicate-elements bg-card/50 sticky top-0 z-20 flex flex-wrap items-center justify-center gap-0.5 border-b py-1', className)} {...props}>
      <UndoRedoButton type="button" action="undo" size="sm" variant="ghost" className={cn(toolbarBtnClassName, 'w-8 min-w-8')} />
      <UndoRedoButton type="button" action="redo" size="sm" variant="ghost" className={cn(toolbarBtnClassName, 'w-8 min-w-8')} />
      <Separator orientation="vertical" data-slot="element" className={toolbarSeparatorClassName} />

      <ListDropdownMenu type="button" variant="ghost" size="sm" className={cn(toolbarBtnClassName)} types={['bulletList', 'orderedList']} />
      <HeadingDropdownMenu type="button" levels={[1, 2, 3, 4, 5]} size="sm" variant="ghost" className={cn(toolbarBtnClassName)} />
      <EmojiCommand type="button" size="sm" variant="ghost" className={cn(toolbarBtnClassName, 'w-8 min-w-8')} />
      <MarkButton type="bold" size="sm" variant="ghost" className={cn(toolbarBtnClassName, 'w-8 min-w-8')} />
      <MarkButton type="italic" size="sm" variant="ghost" className={cn(toolbarBtnClassName, 'w-8 min-w-8')} />
      <MarkButton type="strike" size="sm" variant="ghost" className={cn(toolbarBtnClassName, 'w-8 min-w-8')} />
      <MarkButton type="underline" size="sm" variant="ghost" className={cn(toolbarBtnClassName, 'w-8 min-w-8')} />
      <Separator orientation="vertical" data-slot="element" className={toolbarSeparatorClassName} />
      <InsertTablePopover size="sm" variant="ghost" className={cn(toolbarBtnClassName, 'w-8 min-w-8')} />
      <CellActionButton type="splitCell" size="sm" variant="ghost" className={cn(toolbarBtnClassName, 'w-8 min-w-8')} />
      <CellActionButton type="mergeCells" size="sm" variant="ghost" className={cn(toolbarBtnClassName, 'w-8 min-w-8')} />
      <ToggleHeaderDropdownMenu size="sm" variant="ghost" className={cn(toolbarBtnClassName)} />

      <AddColRowDropdownMenu size="sm" variant="ghost" className={cn(toolbarBtnClassName)} />
      <DeleteDropdownMenu size="sm" variant="ghost" className={cn(toolbarBtnClassName)} />
      <Separator orientation="vertical" data-slot="element" className={toolbarSeparatorClassName} />
      <TextAlignButton align="left" size="sm" variant="ghost" className={cn(toolbarBtnClassName, 'w-8 min-w-8')} />
      <TextAlignButton align="center" size="sm" variant="ghost" className={cn(toolbarBtnClassName, 'w-8 min-w-8')} />
      <TextAlignButton align="right" size="sm" variant="ghost" className={cn(toolbarBtnClassName, 'w-8 min-w-8')} />
      <TextAlignButton align="justify" size="sm" variant="ghost" className={cn(toolbarBtnClassName, 'w-8 min-w-8')} />
      <Separator orientation="vertical" data-slot="element" className={toolbarSeparatorClassName} />

      <SelectMediaButton size="sm" variant="ghost" className={cn(toolbarBtnClassName, 'w-8 min-w-8')} />
    </div>
  );
}
